const DEFAULT_COLOR = "#ff6961"

export function createAnnotationLine(annotation, index, key, value) {
  return {
    type: "line",
    id: `alert${index}_${key}`,
    value,
    borderWidth: 3,
    borderColor: hexToRGB(annotation.color || DEFAULT_COLOR, 0.2),
    display: true,
    scaleID: "y",
    isPinned: false,
    label: {
      enabled: false,
      content: `${annotation.title || ""} ${value}`,
      backgroundColor: "rgba(0,0,0,0.5)",
      padding: 4,
      position: "center",
    },
  }
}

export function hexToRGB(hex, alpha) {
  hex = hex.toUpperCase()

  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export function toggleAnnotation(element, event, enabled, cursor) {
  const chart = event.chart
  const annotationOpts = chart.options.plugins.annotation.annotations.find(
    (e) => e.id == element.options.id
  )
  event.native.target.style.cursor = cursor
  if (!annotationOpts.isPinned) {
    const opacity = enabled ? ["0.2", "0.8"] : ["0.8", "0.2"] // [from, to]
    const scaleID = annotationOpts.scaleID
    annotationOpts.borderColor = annotationOpts.borderColor.replace(
      opacity[0],
      opacity[1]
    )
    annotationOpts.label.enabled = enabled
    if (scaleID === "x") {
      // vertical annotations
      annotationOpts.label.position =
        ((event.y - chart.chartArea.top) / chart.chartArea.height) * 100 + "%"
    } else {
      annotationOpts.label.position =
        ((event.x - chart.chartArea.left) / chart.chartArea.width) * 100 + "%"
    }
    chart.update()
  }
}

export default {
  createAnnotationLine,
  hexToRGB,
  toggleAnnotation,
}
